<template>
  <selector-frame v-if="selector.action" @close="close" :x="-210" :y="-150">
    <template slot="head">
      <div class="tags">
        <span v-for="(tag, i) in selector.tags" :key="i" class="tag">{{ tag }}</span>
      </div>
      <div class="text">
        <p>ドラッグ&ドロップでも画像を追加できます。</p>
      </div>
    </template>
    <div class="tab" slot="nav">
      <a @click="tab = 'public'" :class="{ current: tab === 'public' }">共有画像</a>
      <a v-if="role > 5" @click="tab = 'private'" :class="{ current: tab === 'private' }">PL非公開画像</a>
    </div>
    <div class="ImageSelector" @dragover.prevent @drop.prevent="onDrop">
      <div slot="body" class="images-list">
        <div class="image no-image" @click="select(null)">
          <faicon class="iconb" icon="times" />
        </div>
        <div class="image" v-for="image in images" :key="image.key" @click="select(image.key)">
          <img :src="image.url" draggable="false">
          <faicon class="icon" icon="times" @click.stop="remove(image.key)" />
        </div>
        <label class="image no-image">
          <faicon class="iconb" icon="plus" />
          <input type="file" @change="onChange" multiple="multiple" :style="{ display: 'none' }" />
        </label>
      </div>
    </div>
  </selector-frame>
</template>

<script>
import selectorFrame from '../frames/selector'

export default {
  components: { 'selector-frame': selectorFrame },
  data() {
    return {
      tab: 'public'
    }
  },
  computed: {
    images() {
      const { tab } = this.$data
      const images = this.$store.getters['images/tagged'](this.selector.tags)
      if (tab === 'private') {
        return images.filter((image) => {
          return image.owner
        })
      } else {
        return images.filter((image) => {
          return !image.owner
        })
      }
    },
    selector() {
      return this.$store.getters['selectors/image']
    },
    role() {
      return this.$store.getters['local/role']
    }
  },
  updated() {
    if (this.role < 10) {
      this.$data.tab = 'public'
    }
  },
  methods: {
    onChange(e) {
      const { files } = e.target
      for (var i=0; i<files.length; i++) {
        this.upload(files[i])
      }
      e.target.value = null
    },
    onDrop(e) {
      const files = e.dataTransfer.files
      for (var i=0; i<files.length; i++) {
        this.upload(files[i])
      }
    },
    upload(file) {
      const { tags } = this.selector
      const { role } = this
      const { tab } = this.$data
      const owner = tab === 'private' ? '*' : null
      this.$store.dispatch('images/upload', {
        name: file.name,
        file,
        owner,
        tags
      }).then(doc => {
        this.$emit('select', doc.id)
      }).catch(() => {
        // console.error(err)
        alert('ファイルのアップロードに失敗しました。')
      })
    },
    select(key) {
      this.$store.dispatch(this.selector.action, { value: key, ...this.selector.context })
      this.$store.commit('selectors/close')
    },
    remove(key) {
      this.$store.dispatch('images/remove', key)
    },
    close() {
      this.$store.commit('selectors/close')
    }
  }
}
</script>

<style scoped>
.ImageSelector {
  width: 420px;
  height: 300px;
  display: flex;
  flex-flow: column;
}
.tags {
  display: flex;
}
.text {
  margin-left: 5px;
  font-size: 10px;
  color: #888;
}
.tag {
  border: 1px solid #222;
  padding: 5px 7px;
  border-radius: 15px;
  background: rgba(0, 0, 0, 0.2);
  color: #ccc;
  font-size: 10px;
}
.images-list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  /* overflow: scroll; */
  flex: 1;
}
.image {
  /* margin: 1px; */
  border: 2px solid #222;
  width: 66px;
  height: 66px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.image:hover {
  border-color:#fff;
}
.image .icon {
  padding: 1px;
  border-radius: 0 0 0 2px;
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background: #222;
}
.image .icon:hover {
  background: #888;
}
.no-image {
  background: #222;
}
.no-image .iconb {
  width: 50%;
  height: 50%;
}
.tab {
  display: flex;
}
.tab a {
  border-bottom: 1px solid #222;
  flex: 1;
  text-align: center;
  padding: 5px;
  background: rgba(0, 0, 0, 0.2);
  font-size: 12px;
  color: #888;
}
.tab a.current {
  border-bottom: none;
  /* background: #222; */
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
}
.tab a + a {
  border-left: 1px solid #222;
}
</style>
